import ImpactHero from './ImpactHero.js';
import ImpactMetrics from './ImpactMetrics.js';
import ImpactMap from './ImpactMap.js';
import ImpactStories from './ImpactStories.js';

function SafeSection({ children, fallbackTitle }) {
    const [hasError, setHasError] = React.useState(false);
    
    React.useEffect(() => {
        try {
            if (!children) {
                throw new Error('No content provided');
            }
        } catch (error) {
            console.error('Error in SafeSection:', error);
            setHasError(true);
        }
    }, [children]);

    if (hasError) {
        return (
            <div className="text-center py-8">
                <h2 className="text-2xl font-bold text-gray-700">{fallbackTitle || 'Content Unavailable'}</h2>
            </div>
        );
    }

    return children;
}

function Impact() {
    return (
        <div className="min-h-screen bg-gray-50">
            <SafeSection>
                <ImpactHero />
            </SafeSection>
            <SafeSection>
                <ImpactMetrics />
            </SafeSection>
            <SafeSection>
                <ImpactMap />
            </SafeSection>
            <SafeSection>
                <ImpactStories />
            </SafeSection>
        </div>
    );
}

export default Impact;
